import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import './Prescriptions.css';
import DateRangePickerComponent from '../../CommonComponents/DateRangePickerComponent';
import PrescriptionsListTable from './PrescriptionsListTable';
import PatientInfoPanel from './PatientInfoPanel/PatientInfoPanel';
import NewPrescription from './NewPrescription';
import SearchBar from '../Inpatient/SearchBar';

const Prescriptions = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [prescriptionFilters, setPrescriptionFilters] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const isNewPrescription = location.pathname.endsWith('/newPrescription');
  const isPatientView = location.pathname.includes('/patientInfoPanel/');

  const patient = location.state?.patient;


  if (isNewPrescription) {
    return (
      <NewPrescription
        onBack={() => navigate(-1)}
        draftPrescription={location.state?.draftPrescription}
      />
    );
  }

  if (isPatientView && patient) {
    return (
      <PatientInfoPanel
        patient={patient}
        onBack={() => navigate('/pharmacy/prescriptions')}
      />
    );
  }

  
  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    setPrescriptionFilters(null); // reset search when date changes
  };

  const handleSearch = ({ type, query }) => {
    setPrescriptionFilters({ type, query });
  };

  return (
    <>
      <div className="prescription-toolbar">
        <div className="left-group">
          <div className="search-bar">
          <SearchBar onSearch={handleSearch} />
          </div>
          <div className="date-picker-wrapper">
          <DateRangePickerComponent startDate={startDate}
              endDate={endDate} onDateChange={handleDateChange} />
          </div>
        </div>

        <button
          className="new-request-btn"
          onClick={() => navigate('/pharmacy/prescriptions/newPrescription')}
        >
          <i className="fas fa-file-medical" /> New Prescription
        </button>
      </div>

      <PrescriptionsListTable
        startDate={startDate}
        endDate={endDate}
        prescriptionFilters={prescriptionFilters}
        onSelectPatient={(patient) => {
          if (patient.prescriptionStatus === 'DELETED') {
            return;
          }
          if (patient.prescriptionStatus === 'SAVED') {
            navigate('/pharmacy/prescriptions/newPrescription', {
              state: { draftPrescription: patient },
            });
          } else {
            navigate(`/pharmacy/prescriptions/patientInfoPanel/${patient.id || patient.prescriptionId}`, {
              state: { patient },
            });
          }
        }}
      />
    </>
  );
};

export default Prescriptions;
